import React, { useState, useEffect } from "react";

const CursorTracker = () => {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const updateCursorPosition = (event) => {
      setCursorPosition({ x: event.clientX, y: event.clientY });
    };

    // Attach the mousemove listener to the entire window
    window.addEventListener("mousemove", updateCursorPosition);

    return () => {
      // Clean up the event listener
      window.removeEventListener("mousemove", updateCursorPosition);
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed", // Ensure it's always relative to the viewport
        left: `${cursorPosition.x}px`,
        top: `${cursorPosition.y}px`,
        width: "10px", // Adjust size
        height: "10px",
        backgroundColor: "blue", // Customize color
        borderRadius: "50%", // Make it circular
        pointerEvents: "none", // Ensure it doesn't interfere with other elements
        zIndex: 9999, // Make it appear above everything
        transform: "translate(-50%, -50%)", // Center on the cursor
      }}
    ></div>
  );
};

export default CursorTracker;
